import { render, staticRenderFns } from "./table-head.vue?vue&type=template&id=323231ce"
import script from "./table-head.vue?vue&type=script&lang=ts"
export * from "./table-head.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports